/* Default photo of each Featured categories tile, keyed by category code.
   Copied verbatim from the portal's
   src/components/Common/GrapesEditor/categoryTileImages.js, which owns it —
   keep the two in sync. Served from this origin because stores published
   before the defaults existed carry product photos, and newer markup points at
   the portal's origin. */
const TILE_FILES = {
  // Pet
  beds_home: 'beds-home-01.jpg',
  food: 'food-01.jpg',
  feeding_supplies: 'feeding-supplies-02.jpg',
  treats: 'treats-01.jpg',
  toys: 'toys-01.jpg',
  grooming: 'grooming-01.jpg',
  collars_leashes_harnesses: 'collars-leashes-harnesses-03.jpg',
  health_wellness: 'health-wellness-01.jpg',
  pet_parents: 'pet-parents-01.jpg',
  tech: 'pet-tech-01.jpg',
  clothing_accessories: 'clothing-accessories-01.jpg',
  travel_outdoor: 'travel-outdoor-01.jpg',
  potty_waste_management: 'potty-cleanup-01.jpg',
  training: 'training-behavior-01.jpg',
  training_behavior: 'training-behavior-01.jpg',
  horse: 'horse-01.jpg',
  // Dental
  teeth_whitening: 'teeth-whitening-01.png',
  toothbrushes: 'toothbrushes-01.jpg',
  floss_interdental: 'floss-interdental-01.jpg',
  mouthwash_rinses: 'mouthwash-rinses-01.jpg',
  specialty_care: 'specialty-care-01.jpg',
  guards_mouthguards: 'guards-mouthguards-01.jpg',
  kits_bundles: 'kits-bundles-01.jpg',
  accessories: 'accessories-01.jpg',
  breath_fresheners: 'breath-fresheners-01.jpg',
  childrens_oral_care: 'childrens-oral-care-01.jpg',
  orthodontic_care: 'orthodontic-care-01.jpg',
  pet_dental: 'pet-dental-01.jpg',
  // Health
  muscle_joint_care: 'muscle-joint-care-01.jpg',
  movement_rehabilitation: 'movement-rehabilitation-01.jpg',
  sleep_relaxation: 'sleep-relaxation-01.jpg',
  mental_health_stress: 'mental-health-stress-01.jpg',
  womens_pelvic_health: 'womens-pelvic-health-01.jpg',
  gut_metabolic_health: 'gut-metabolic-health-07.jpg',
  daily_living_adaptive_aids: 'daily-living-adaptive-aids-01.jpg',
  education_resources: 'education-resources-01.jpg',
};

const tileImageUrl = (code) => {
  const file = TILE_FILES[code];
  return file ? `${process.env.PUBLIC_URL}/category-tiles/${file}` : '';
};

// Codes without a default keep whatever photo the published markup carries.
export const applyCategoryTileImages = (container) => {
  if (!container) return;
  container.querySelectorAll('a.sf-cat').forEach((tile) => {
    const code = new URL(tile.getAttribute('href') || '', window.location.origin).searchParams.get('category');
    const src = tileImageUrl(code);
    const frame = tile.querySelector('.sf-catimg');
    if (!src || !frame) return;
    const img = frame.querySelector('img');
    if (img) {
      img.src = src;
      return;
    }
    frame.innerHTML = '<img alt="" loading="lazy">';
    frame.querySelector('img').src = src;
  });
};
